import { IonToast } from '@ionic/react'
import { useStore } from 'effector-react'
import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { $notifications, snackbarClosed } from './model'

type Props = { children: ReactNode }

export function Provider({ children }: Props) {
  const { t } = useTranslation()

  const notifications = useStore($notifications)

  return (
    <>
      {notifications.map(({ message, messageI18n, variant, key }) => (
        <IonToast
          key={key}
          isOpen
          message={message ?? t(messageI18n)}
          duration={30000}
          position='top'
          swipeGesture='vertical'
          buttons={[
            {
              text: t('button.close'),
            },
          ]}
          color={variant}
          translucent
          onDidDismiss={() => snackbarClosed(key)}
        />
      ))}

      <>{children}</>
    </>
  )
}
